import { useFormik } from 'formik';
import { useEffect, useCallback } from 'react';
var removeEmptyPropertiesFromObject = function (obj) {
    Object.keys(obj).forEach(function (k) { return !obj[k] && obj[k] !== undefined && delete obj[k]; });
};
var removeEmptySpace = function (obj) {
    Object.keys(obj).map(function (k) { return (obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]); });
};
export function useMyFormik(config) {
    var formik = useFormik(config);
    var setValues = formik.setValues, values = formik.values;
    var removeEmptyProperties = useCallback(function (values) {
        removeEmptyPropertiesFromObject(values);
    }, []);
    useEffect(function () {
        if (config.removeEmptyValues) {
            removeEmptyProperties(values);
        }
    }, [setValues, values, removeEmptyProperties, config.removeEmptyValues]);
    useEffect(function () {
        if (config.removeEmptySpace) {
            removeEmptySpace(values);
        }
    }, [setValues, values, config.removeEmptySpace]);
    return formik;
}
